// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Section Fallback CSS Module
 */
.FHy0k5lhn2WdfwQmzwbU {
  width: 100%;
  min-height: 200px;
  background: var(--cardBackground, #2a2a2a);
  border: 1px solid var(--border, #3a3a3a);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  text-align: center;
}
.jIC_Q2Y_QkjZwealog0X {
  font-size: 32px;
  color: var(--warning, #ffc107);
  margin-bottom: 16px;
}
.yrZWgRJ0zQzytiB9OKAg {
  color: var(--textPrimary, #ffffff);
  font-size: 16px;
  margin: 0 0 8px 0;
}
.HFM_Z3bNHQ4Asdk30SDn {
  color: var(--textSecondary, #b0b0b0);
  font-size: 14px;
  margin: 0 0 16px 0;
  line-height: 1.4;
}
.QBNZ9t6_nWuiiIS62pSw {
  background: var(--primary, #7200B9);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.QBNZ9t6_nWuiiIS62pSw:hover {
  background: var(--primaryHover, #8a00e0);
}
.w4rj3tn9DUmGi3ABls4G {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/MultiViewCampaignSection/components/CampaignSectionFallback/CampaignSectionFallback.module.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB","sourcesContent":["/**\n * Campaign Section Fallback CSS Module\n */\n.fallbackContainer {\n  width: 100%;\n  min-height: 200px;\n  background: var(--cardBackground, #2a2a2a);\n  border: 1px solid var(--border, #3a3a3a);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  text-align: center;\n}\n.errorIcon {\n  font-size: 32px;\n  color: var(--warning, #ffc107);\n  margin-bottom: 16px;\n}\n.errorTitle {\n  color: var(--textPrimary, #ffffff);\n  font-size: 16px;\n  margin: 0 0 8px 0;\n}\n.errorMessage {\n  color: var(--textSecondary, #b0b0b0);\n  font-size: 14px;\n  margin: 0 0 16px 0;\n  line-height: 1.4;\n}\n.button {\n  background: var(--primary, #7200B9);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.button:hover {\n  background: var(--primaryHover, #8a00e0);\n}\n.buttonGroup {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallbackContainer": `FHy0k5lhn2WdfwQmzwbU`,
	"errorIcon": `jIC_Q2Y_QkjZwealog0X`,
	"errorTitle": `yrZWgRJ0zQzytiB9OKAg`,
	"errorMessage": `HFM_Z3bNHQ4Asdk30SDn`,
	"button": `QBNZ9t6_nWuiiIS62pSw`,
	"buttonGroup": `w4rj3tn9DUmGi3ABls4G`
};
export default ___CSS_LOADER_EXPORT___;
